<div class="form-group input-datepicker">
  <div class="form-control">
    <i class="fa fa-calendar"></i>
    <ngx-datepicker  [options]="options" #datepicker
    [(ngModel)]="date" [disabled]="false" (ngModelChange)="changedDate($event)"></ngx-datepicker>
    <i class="fa fa-times" aria-hidden="true" (click)="clearDate()" [hidden]="!date"></i>
  </div> 
</div>